import * as React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import "bootstrap/dist/css/bootstrap.css";
import { Card } from "react-bootstrap";

export default function LoadingSkeleton() {
  return (
    <div>
      <Card>
        <div className="py-4 px-4">
          <Stack spacing={1}>
            <Skeleton variant="rectangular" height={90} />
            <div style={{ paddingTop: "80px" }}></div>
            <div className="row my-3">
              <div className="col-2"></div>
              <div className="col-4">
                <Skeleton variant="rectangular" height={350} />
              </div>
              <div className="col-1"></div>
              <div className="col-4">
                <Skeleton variant="rectangular" height={350} />
              </div>
            </div>
            <div className="row my-3">
              <div className="col-2"></div>
              <div className="col-4">
                <Skeleton variant="rectangular" height={350} />
              </div>
              <div className="col-1"></div>
              <div className="col-4"></div>
            </div>
            <div style={{ height: "45vh" }}></div>
          </Stack>
        </div>
      </Card>
    </div>
  );
}
